import { render } from "./GerenciarEtapas.vue?vue&type=template&id=0301e108"
import script from "./GerenciarEtapas.vue?vue&type=script&lang=js"
export * from "./GerenciarEtapas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__